/**
 * Update slider after load new blog articles.
 */
document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('[js-featured-blog="carousel"]');
  document.querySelector('.featured-blog__load-more-button').addEventListener('click', (event) => {
    slider.querySelectorAll('.featured-blog__post.small-hide').forEach((slide) => {
      slide.classList.remove('small-hide');
    });
    event.target.classList.add('hidden');
  });
});
